import * as React from 'react';
import { UIHeading1, UIHeading2, UIText1, UIText2, useDeviceType } from '@cian/ui-kit';

import * as styles from './Advantages.css';

export const Advantages: React.FC = () => {
  const deviceType = useDeviceType();
  const UIHeading = deviceType === 'phone' ? UIHeading2 : UIHeading1;
  const UIText = deviceType === 'phone' ? UIText2 : UIText1;

  return (
    <section className={styles['advantage-list']}>
      <div className={styles['individual-advantage']}>
        <div className={styles['individual-image']} />
        <div className={styles['individual-text']}>
          <UIHeading>Индивидуальный подход</UIHeading>
          <div className={styles['description']}>
            <UIText>Изучим все ваши требования к квартире мечты, из&nbsp;тысяч объявлений выберем подходящие</UIText>
          </div>
        </div>
      </div>
      <div className={styles['time-advantage']}>
        <div className={styles['time-image']} />
        <div className={styles['time-text']}>
          <UIHeading>Сэкономим ваше время</UIHeading>
          <div className={styles['description']}>
            <UIText>Вам не нужно просматривать тысячи объявлений в&nbsp;поисках идеального варианта</UIText>
          </div>
        </div>
      </div>
      <div className={styles['builder-advantage']}>
        <div className={styles['builder-image']} />
        <div className={styles['builder-text']}>
          <UIHeading>Расскажем о застройщиках</UIHeading>
          <div className={styles['description']}>
            <UIText>Специалисты знают историю строительных компаний и&nbsp;в&nbsp;курсе подробностей про все ЖК</UIText>
          </div>
        </div>
      </div>
      <div className={styles['market-advantage']}>
        <div className={styles['market-image']} />
        <div className={styles['market-text']}>
          <UIHeading>Знаем рынок</UIHeading>
          <div className={styles['description']}>
            <UIText>Подскажем, у какой квартиры лучшее соотношение&nbsp;цена/качество</UIText>
          </div>
        </div>
      </div>
      <div className={styles['one-call-advantage']}>
        <div className={styles['one-call-image']} />
        <div className={styles['one-call-text']}>
          <UIHeading>Всего один звонок</UIHeading>
          <div className={styles['description']}>
            <UIText>
              Консультант уточнит пару вопросов, найдёт объявления,&nbsp;и&nbsp;хотя бы одно точно вам подойдёт
            </UIText>
          </div>
        </div>
      </div>
      <div className={styles['free-advantage']}>
        <div className={styles['free-image']} />
        <div className={styles['free-text']}>
          <UIHeading>И всё это — бесплатно</UIHeading>
          <div className={styles['description']}>
            <UIText>Подберем квартиру, проконсультируем и&nbsp;ответим на&nbsp;все ваши вопросы</UIText>
          </div>
        </div>
      </div>
    </section>
  );
};
